import { ObservableUnwrapped } from "./ObservableUnwrapped.js";
export function unwrapObservable(origin, derive) {
    return new ObservableUnwrapped(origin, derive);
}
